export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-16">
            <div className="flex-1">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
                关于我们
              </h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                51吃瓜黑料网成立于2024年，是国内领先的娱乐事件聚合与吃瓜讨论平台。我们致力于为吃瓜群众打造一个信息全面、更新及时、讨论热烈的热点事件中心。
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                从明星八卦到网红争议，从影视剧热点到社会大事件，我们的编辑团队保持7×24小时全网监测，确保每一个值得关注的瓜都不会从你眼前溜走。我们相信，理性吃瓜是一种生活态度，围观也是一种参与。
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                截至2026年7月，平台已累计收录超过12,680条爆料事件，汇聚了8.6万活跃吃瓜群众，日均话题讨论量突破百万。51吃瓜黑料网已成为口碑最好的吃瓜爆料第一站。
              </p>
            </div>
            <div className="flex-shrink-0 w-full max-w-md">
              <div className="grid grid-cols-2 gap-3">
                <div className="bg-primary-50 rounded-xl p-5 text-center">
                  <div className="text-2xl font-heading font-bold text-primary-600">12,680+</div>
                  <div className="text-xs text-foreground-500 mt-1">爆料事件</div>
                </div>
                <div className="bg-accent-50 rounded-xl p-5 text-center">
                  <div className="text-2xl font-heading font-bold text-accent-600">8.6万</div>
                  <div className="text-xs text-foreground-500 mt-1">吃瓜群众</div>
                </div>
                <div className="bg-secondary-50 rounded-xl p-5 text-center">
                  <div className="text-2xl font-heading font-bold text-secondary-600">100万+</div>
                  <div className="text-xs text-foreground-500 mt-1">日讨论量</div>
                </div>
                <div className="bg-primary-50 rounded-xl p-5 text-center">
                  <div className="text-2xl font-heading font-bold text-primary-600">24h</div>
                  <div className="text-xs text-foreground-500 mt-1">全天候更新</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}